import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import TreeDiagram from './components/TreeDiagram';
import QualitativeMatrixGroup from './components/QualitativeMatrixGroup';
import PaletSmartgrid from './components/PaletSmartgrid';
import PaletExternality from './components/PaletExternality';
import CustomPalette from './components/CustomPalette';
import VerticalBarChart from './components/VerticalBarChart';
import ListAlternatives from './components/ListAlternatives';
import EditAlternatives from './components/EditAlternatives';
import RadarChart from './components/RadarChart';
import PieChart from './components/PieChart';
import LineChart from './components/LineChart';
import BarChart from './components/BarChart';
import AutocompleteTags from './components/AutocompleteTags';
import ListShared from './components/ListShared';
import SingleSelect from './components/SingleSelect';
import CBATable from './components/CBATable';
import CBATableResults from './components/CBATableResults';
import { createRoot } from 'react-dom/client';
import PMCATable from './components/PMCATable';
import KPITreeTable from './components/KPITreeTable';

window.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById('root')) {
        createRoot(document.getElementById('root')).render(<App />);
    }
    
    if (document.getElementById('tree-diagram')) {
        var elementTreeDiagram = document.getElementById('tree-diagram');
        createRoot(elementTreeDiagram).render(<TreeDiagram pastruct={elementTreeDiagram.getAttribute('data-pastruct')} />);
    }
    if (document.getElementsByClassName('qualitative-matrix')) {
        var elementsQualitativeMatrix = document.getElementsByClassName('qualitative-matrix');
        var group = "";
        for (var i = 0; i < elementsQualitativeMatrix.length; i++) {
            group = elementsQualitativeMatrix[i].getAttribute('group');
            createRoot(elementsQualitativeMatrix[i]).render(<QualitativeMatrixGroup qualitativematrix={elementsQualitativeMatrix[i].getAttribute('data-qualitativematrix')} group={group} />);
        }
    }
    
    if (document.getElementById('palet-smartgrid')) {
        var elementsPaletSmartgrid = document.getElementById('palet-smartgrid');
        createRoot(elementsPaletSmartgrid).render(<PaletSmartgrid
            hierarchykpis={elementsPaletSmartgrid.getAttribute('data-hierarchykpis')}
            criterias={elementsPaletSmartgrid.getAttribute('data-criterias')} />);
    }
    if (document.getElementById('palet-externality')) {
        var elementsPaletExternality = document.getElementById('palet-externality');
        createRoot(elementsPaletExternality).render(<PaletExternality
            hierarchykpis={elementsPaletExternality.getAttribute('data-hierarchykpis')}
            kpislist={elementsPaletExternality.getAttribute('data-kpislist')}
            criterias={elementsPaletExternality.getAttribute('data-criterias')} />);
    }
    
    if (document.getElementById('custom-palette')) {
        var elementsCustomPalette = document.getElementById('custom-palette');
        createRoot(elementsCustomPalette).render(<CustomPalette
            criteria={elementsCustomPalette.getAttribute('data-criteria')}
            kpis={elementsCustomPalette.getAttribute('data-kpis')} />);
    }
    
    if (document.getElementsByClassName('vertical-barchart')) {
        var elementsVerticalBarChart = document.getElementsByClassName('vertical-barchart');
        for (i = 0; i < elementsVerticalBarChart.length; i++) {
            createRoot(elementsVerticalBarChart[i]).render(<VerticalBarChart values={elementsVerticalBarChart[i].getAttribute('data-values')} />);
        }
    }
    
    if (document.getElementById('list-alternatives')) {
        var listAlternatives = document.getElementById('list-alternatives');
        createRoot(listAlternatives).render(<ListAlternatives
            alternatives={listAlternatives.getAttribute('data-alternatives')}/>);
    }
    
    if (document.getElementById('edit-alternatives')) {
        var editAlternatives = document.getElementById('edit-alternatives');
        createRoot(editAlternatives).render(<EditAlternatives
            alternatives={editAlternatives.getAttribute('data-alternatives')}/>);
    }
    
    if (document.getElementsByClassName('pie-chart')) {
        var elementsPieChart = document.getElementsByClassName('pie-chart');
        for (i = 0; i < elementsPieChart.length; i++) {
            createRoot(elementsPieChart[i]).render(<PieChart values={elementsPieChart[i].getAttribute('data-values')} />);
        }
    }
    
    if (document.getElementsByClassName('line-chart')) {
        var elementsLineChart = document.getElementsByClassName('line-chart');
        for (i = 0; i < elementsLineChart.length; i++) {
            createRoot(elementsLineChart[i]).render(<LineChart values={elementsLineChart[i].getAttribute('data-values')} />);
        }
    }
    
    if (document.getElementsByClassName('radar-chart')) {
        var elementsRadarChart = document.getElementsByClassName('radar-chart');
        for (i = 0; i < elementsRadarChart.length; i++) {
            createRoot(elementsRadarChart[i]).render(<RadarChart values={elementsRadarChart[i].getAttribute('data-values')} />);
        }
    }
    
    if (document.getElementsByClassName('bar-chart')) {
        var elementsBarChart = document.getElementsByClassName('bar-chart');
        for (i = 0; i < elementsBarChart.length; i++) {
            createRoot(elementsBarChart[i]).render(<BarChart values={elementsBarChart[i].getAttribute('data-values')} />);
        }
    }
    
    if (document.getElementsByClassName('autocomplete-tags')) {
        var elementsAutocompleteTags = document.getElementsByClassName('autocomplete-tags');
        for (i = 0; i < elementsAutocompleteTags.length; i++) {
            createRoot(elementsAutocompleteTags[i]).render(<AutocompleteTags values={elementsAutocompleteTags[i].getAttribute('data-values')} 
            selected={elementsAutocompleteTags[i].getAttribute('data-selected')} />);
        }
    }
    
    if (document.getElementsByClassName('list-shared')) {
        var elementsListShared = document.getElementsByClassName('list-shared');
        for (i = 0; i < elementsListShared.length; i++) {
            createRoot(elementsListShared[i]).render(<ListShared values={elementsListShared[i].getAttribute('data-values')} 
            selected={elementsListShared[i].getAttribute('data-selected')} 
            form={elementsListShared[i].getAttribute('data-form')} />);
        }
    }
    
    if (document.getElementsByClassName('single-select')) {
        var elementsSingleSelect = document.getElementsByClassName('single-select');
        for (i = 0; i < elementsSingleSelect.length; i++) {
            createRoot(elementsSingleSelect[i]).render(<SingleSelect values={elementsSingleSelect[i].getAttribute('data-values')} />);
        }
    }

    if (document.getElementsByClassName('cba-table')) {
        var elementsCbaTable = document.getElementsByClassName('cba-table');
        for (i = 0; i < elementsCbaTable.length; i++) {
            createRoot(elementsCbaTable[i]).render(<CBATable data={elementsCbaTable[i].getAttribute('data-values')} standalone={elementsCbaTable[i].getAttribute('standalone')} />);
        }
    }

    if (document.getElementsByClassName('cba-table-results')) {
        var elementsCbaTableResults = document.getElementsByClassName('cba-table-results');
        for (i = 0; i < elementsCbaTableResults.length; i++) {
            createRoot(elementsCbaTableResults[i]).render(<CBATableResults data={elementsCbaTableResults[i].getAttribute('data-values')} />);
        }
    }

    if (document.getElementsByClassName('pmca-table')) {
        var elementsPmcaTableResults = document.getElementsByClassName('pmca-table');
        for (i = 0; i < elementsPmcaTableResults.length; i++) {
            createRoot(elementsPmcaTableResults[i]).render(<PMCATable data={elementsPmcaTableResults[i].getAttribute('data-values')} />);
        }
    }

    if (document.getElementsByClassName('kpi-tree-table')) {
        var elementsKpiTreeTableResults = document.getElementsByClassName('kpi-tree-table');
        for (i = 0; i < elementsKpiTreeTableResults.length; i++) {
            createRoot(elementsKpiTreeTableResults[i]).render(<KPITreeTable data={elementsKpiTreeTableResults[i].getAttribute('data-values')} header={elementsKpiTreeTableResults[i].getAttribute('header-values')} />);
        }
    }
});


